import "./displayfollowing.css";
const DisplayFollowing = () => {
  return (
    <div className="displayFollowing">
      The user has set this section to private.
    </div>
  );
};

export default DisplayFollowing;
